import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { operatoriAvvisoApi } from '../../services/api'
import { RedOperatoreAvviso } from '../../types/red'

interface Props {
  onClose: () => void
  onCreated: (operatore: RedOperatoreAvviso) => void
}

const NuovoOperatoreAvvisoModal: React.FC<Props> = ({ onClose, onCreated }) => {
  const [nome, setNome] = useState('')
  const [email, setEmail] = useState('')
  const [telefono, setTelefono] = useState('')
  const [saving, setSaving] = useState(false)

  const handleSalva = async () => {
    if (!nome.trim()) {
      toast.error('Il nome è obbligatorio')
      return
    }
    if (!email.trim() && !telefono.trim()) {
      toast.error('Inserisci almeno un contatto (email o WhatsApp)')
      return
    }
    setSaving(true)
    try {
      const res = await operatoriAvvisoApi.create({
        nome: nome.trim(),
        email: email.trim() || undefined,
        telefono_whatsapp: telefono.trim() || undefined,
      })
      toast.success('Operatore creato')
      onCreated(res.data)
      onClose()
    } catch (err: any) {
      toast.error(err?.response?.data?.detail || 'Errore creazione operatore')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => !saving && onClose()}>
      <div className="bg-white rounded-xl p-6 max-w-sm w-full" onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-semibold mb-1">Nuovo operatore avviso</h3>
        <p className="text-sm text-gray-500 mb-4">Riceverà gli avvisi email/WhatsApp per le scadenze RED.</p>
        <div className="space-y-3">
          <div>
            <label className="label text-xs">Nome</label>
            <input className="input" value={nome} onChange={e => setNome(e.target.value)} autoFocus />
          </div>
          <div>
            <label className="label text-xs">Email</label>
            <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="mario.rossi@example.com" />
          </div>
          <div>
            <label className="label text-xs">Telefono WhatsApp</label>
            <input className="input" value={telefono} onChange={e => setTelefono(e.target.value)} placeholder="+393331234567" />
          </div>
          <p className="text-xs text-gray-400">Serve almeno un contatto tra email e WhatsApp.</p>
        </div>
        <div className="flex gap-2 mt-4">
          <button onClick={handleSalva} disabled={saving} className="btn-primary text-sm">
            {saving ? 'Creazione...' : 'Crea operatore'}
          </button>
          <button onClick={onClose} disabled={saving} className="text-sm text-gray-500">Annulla</button>
        </div>
      </div>
    </div>
  )
}

export default NuovoOperatoreAvvisoModal
